import { render, staticRenderFns } from "./IndividualPaystubs.vue?vue&type=template&id=5ae125eb&scoped=true&"
import script from "./IndividualPaystubs.vue?vue&type=script&lang=ts&"
export * from "./IndividualPaystubs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae125eb",
  null
  
)

export default component.exports